import React from "react";
import styled from "styled-components";
import { Inline } from "../layout";
import { useTranslation } from "react-i18next";

const Wrapper = styled(Inline)`
  background: ${({ theme }) => theme.grey};
  /* width: ${(props) => (props.full ? "100%" : "60%")}; */
  padding: 0.7rem 3rem;
  @media (max-width: 768px) {
    width: 100% !important;
    margin: ${(props) => (props.full ? "0" : "0px 150px")};
  }
  .wrapper {
    position: relative;
    input {
      -webkit-appearance: none;
      appearance: none;
      position: absolute;
      z-index: 99999;
      width: 100%;
      height: 100%;
      cursor: pointer;
      top: 0;
      left: 0;
      &:checked ~ p {
        font-weight: 500;
        border-bottom: 1px solid ${({ theme }) => theme.black};
        padding-bottom: 0.6rem;
        margin-bottom: -0.6rem;
      }
    }
    p {
      position: relative;
      font-family: ${({ theme }) => theme.fonts.sofia};
      font-weight: 300;
      font-size: 1.25rem;
      white-space: nowrap;
      cursor: pointer;
      @media (max-width: 768px) {
        font-size: 17px;
      }
    }

    &:hover p {
      border-bottom: 1px solid ${({ theme }) => theme.black};
      padding-bottom: 0.6rem;
      margin-bottom: -0.6rem;
    }
  }
`;

function FilterTabs({ setStatus, status, array, ALL_ARRAY, full }) {
  const { t } = useTranslation();

  // Keep the radio values as the original English identifiers so existing
  // filter logic continues to work while we translate the visible labels.
  const tabs = [
    { name: "All", labelKey: "filter.all" },
    { name: "See", labelKey: "filter.see" },
    { name: "Do", labelKey: "filter.do" },
    { name: "Eat & Drink", labelKey: "filter.eatAndDrink" },
  ];

  return (
    <Wrapper full={full} justify="center" gap="30px">
      {tabs.map((tab, i) => {
        const condition = i === 0 && array === null;
        return (
          <div key={i + "nbvc"} className="wrapper">
            <input
              name="filter"
              type="radio"
              value={tab.name}
              checked={status === tab.name ? true : condition ? true : false}
              onChange={(e) => setStatus(e.target.value)}
            />
            <p>{t(tab.labelKey)}</p>
          </div>
        );
      })}
    </Wrapper>
  );
}

/** @component */
export default FilterTabs;
